import * as z from "zod"

export const contestRegistrationSchema = z.object({
  // School information
  schoolName: z.string()
    .min(2, { message: "Le nom de l'établissement doit contenir au moins 2 caractères" }),
  schoolAddress: z.string()
    .min(5, { message: "L'adresse doit contenir au moins 5 caractères" }),
  schoolPostalCode: z.string()
    .regex(/^\d{5}$/, { message: "Le code postal doit contenir 5 chiffres" }),
  schoolCity: z.string()
    .min(2, { message: "La ville doit contenir au moins 2 caractères" }),
  schoolPhone: z.string()
    .min(10, { message: "Le téléphone doit contenir au moins 10 chiffres" }),
  schoolEmail: z.string()
    .email({ message: "Email établissement invalide" }),
  academy: z.string()
    .min(2, { message: "Veuillez sélectionner une académie" }),
  principalName: z.string()
    .min(2, { message: "Le nom du chef d'établissement doit contenir au moins 2 caractères" }),
  
  // Teacher information
  teacherName: z.string()
    .min(2, { message: "Le nom de l'enseignant doit contenir au moins 2 caractères" }),
  teacherFunction: z.string()
    .min(2, { message: "La fonction doit contenir au moins 2 caractères" }),
  teacherPhone: z.string()
    .min(10, { message: "Le téléphone doit contenir au moins 10 chiffres" }),
  teacherEmail: z.string()
    .email({ message: "Email enseignant invalide" }),
  
  // Class information
  classLevel: z.enum(["4e", "3e", "2de"], {
    errorMap: () => ({ message: "Veuillez sélectionner un niveau de classe" })
  }),
  className: z.string()
    .min(1, { message: "Le nom de la classe est obligatoire" })
    .max(50, { message: "Le nom de la classe ne peut pas dépasser 50 caractères" }),
  participantsCount: z.number()
    .min(1, { message: "Le nombre d'élèves participants doit être au moins 1" })
    .max(100, { message: "Le nombre d'élèves participants ne peut pas dépasser 100" }),
  totalStudentsCount: z.number()
    .min(1, { message: "Le nombre total d'élèves doit être au moins 1" })
    .max(100, { message: "Le nombre total d'élèves ne peut pas dépasser 100" }),
  
  // Category
  category: z.enum(["mots", "images", "son"], {
    errorMap: () => ({ message: "Veuillez sélectionner une catégorie" })
  }),
  
  // Principal approval
  principalApproval: z.boolean().refine((val) => val === true, {
    message: "Vous devez certifier avoir obtenu l'accord du chef d'établissement"
  })
}).refine((data) => data.participantsCount <= data.totalStudentsCount, {
  message: "Le nombre d'élèves participants ne peut pas dépasser le nombre total d'élèves",
  path: ["participantsCount"]
})

export type ContestRegistrationFormValues = z.infer<typeof contestRegistrationSchema>
